import { render, staticRenderFns } from "./ViewProjectModal.vue?vue&type=template&id=2548a7d4"
import script from "./ViewProjectModal.vue?vue&type=script&lang=ts"
export * from "./ViewProjectModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports